import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import MyPosts from '../Overview/Sections/MyPosts';
import { translate } from '@haldor/ui';
var AllPosts = /*#__PURE__*/function (_Component) {
  function AllPosts() {
    var _this;
    _classCallCheck(this, AllPosts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AllPosts, [].concat(args));
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('Posts'));
    });
    return _this;
  }
  _inherits(AllPosts, _Component);
  return _createClass(AllPosts, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, this.props.students != null ? /*#__PURE__*/React.createElement(MyPosts, null) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    students: state.guardians.students,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle
})(AllPosts);